import React, { useEffect, useState } from "react";
import { confirmAlert } from 'react-confirm-alert';
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from 'react-router-dom';
import Avatar from "../assets/img/figure/admin.jpg";
import trau from "../assets/img/ic-bantin.png";
import { resetRedux } from "../redux/Actions";
import { actions } from "../redux/authRedux";

const _ = require('lodash');
//904832009
export default function SiderBar({ menuShow }) {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { countcv } = useSelector((state) => state.save);
    const info = user && user.data ? user.data : null;
    const MyRole = JSON.parse(user && user.data.roles ? user.data.roles : '{}')
    const location = useLocation();
    let localsegment = location.pathname;

    // Khớp menu cho cả trang danh sách lẫn trang con/form của nó.
    // VD link="/learninghub_dethi" sẽ active khi đứng ở: /learninghub_dethi,
    // /add-learninghub_dethi, /edit-learninghub_dethi/5 ...
    const isMenuActive = (link) => {
        if (!link) return false;
        if (localsegment === link) return true;
        const name = _.trimStart(link, '/'); // 'learninghub_dethi'
        return (
            localsegment.startsWith(link + '/') ||      // /learninghub_dethi/5
            localsegment.startsWith('/add-' + name) ||  // /add-learninghub_dethi
            localsegment.startsWith('/edit-' + name) || // /edit-learninghub_dethi/5
            localsegment.startsWith('/view-' + name) ||
            localsegment.startsWith('/approve-' + name)
        );
    };



    let listMenus = [
        // { title: 'Bảng tin', icon: 'flaticon-dashboard', link: '/bang-tin' },
        { title: 'Báo cáo công việc', icon: 'fas fa-chart-line', link: '/baocaocongviec' },
        {
            title: 'Dịch vụ hành chính', icon: 'fas fa-paper-plane', link: '', active: ['/van-thu', '/vanthu_param', '/phan-cong-cap-so', '/huong-dan-van-thu', '/dat-xe', '/dat-phong-hop', '/quan-ly-xe', '/quan-ly-phong-hop', 'bao-cao-xe-phong-hop', '/dat-cho-ngoi', '/checkin-cho-ngoi', '/dia-diem-cho-ngoi', '/add-dia-diem-cho-ngoi', '/edit-dia-diem-cho-ngoi'].includes(localsegment), children: [
                { title: 'Văn thư lưu trữ', icon: 'fas fa-angle-right', link: '/van-thu' },
                { title: 'Hướng dẫn nghiệp vụ văn thư', icon: 'fas fa-angle-right', link: '/huong-dan-van-thu', enable: true },
                { title: 'Phân loại văn thư', icon: 'fas fa-angle-right', link: '/vanthu_param' },
                { title: 'Phân công cấp số', icon: 'fas fa-angle-right', link: '/phan-cong-cap-so' },
                { title: 'Đặt xe', icon: 'fas fa-angle-right', link: '/dat-xe' },
                { title: 'Đặt phòng họp', icon: 'fas fa-angle-right', link: '/dat-phong-hop' },
                { title: 'Quản lý xe', icon: 'fas fa-angle-right', link: '/quan-ly-xe' },
                { title: 'Quản lý phòng họp', icon: 'fas fa-angle-right', link: '/quan-ly-phong-hop' },
                { title: 'Coworking', icon: 'fas fa-angle-right', link: '/dat-cho-ngoi', id: 'dat-cho-ngoi' },
                { title: 'Quản lý địa điểm & chỗ ngồi', icon: 'fas fa-angle-right', link: '/dia-diem-cho-ngoi', id: 'quan-tri-cho-ngoi' },

            ]
        },
        {
            title: 'Tờ trình', icon: 'far fa-calendar-check', link: '', active: ['/workflow_type', '/workflow_walking', '/huong-dan-to-trinh'].includes(localsegment), children: [
                { title: 'Phân loại tờ trình', icon: 'fas fa-angle-right', link: '/workflow_type' },
                { title: 'Danh sách tờ trình', icon: 'fas fa-angle-right', link: '/workflow_walking' },
                { title: 'Hướng dẫn', icon: 'fas fa-angle-right', link: '/huong-dan-to-trinh', enable: true },
            ]
        },

        {
            title: 'Dịch vụ mua sắm', icon: 'fas fa-luggage-cart', link: '', active: ['/purchasing_supplier', '/purchasing_walking'].includes(localsegment), children: [
                { title: 'Quản lý nhà cung cấp', icon: 'fas fa-angle-right', link: '/purchasing_supplier' },
                { title: 'Dịch vụ mua sắm', icon: 'fas fa-angle-right', link: '/purchasing_walking' },
            ]
        },
        {
            title: 'Quản lý công việc', icon: 'fas fa-journal-whills', link: '', active: ['/works_mission', '/works_order'].includes(localsegment), children: [
                { title: 'Quản lý nghiệp vụ', icon: 'fas fa-angle-right', link: '/works_mission' },
                { title: 'Quản lý công việc', icon: 'fas fa-angle-right', link: '/works_order' },
            ]
        },
        {
            title: 'Learning Hub', enable:true, icon: 'fas fa-book-reader', link: '', active: ['/learning_profile_manager', '/khoa-hoc', '/learninghub-profile', '/learninghub_baigiang', '/learninghub_cauhoi', '/learninghub_dethi', '/learninghub_bailam', '/bai-kiem-tra', '/huong-dan-learning-admin', '/huong-dan-learning-hoc-sinh'].includes(localsegment), children: [
                { title: 'Profile' ,enable:true, icon: 'fas fa-angle-right', link: '/learninghub-profile' },
                { title: 'Khóa học',enable:true, icon: 'fas fa-angle-right', link: '/khoa-hoc' },
                { title: 'Quản lý Profile', icon: 'fas fa-angle-right', link: '/learning_profile_manager' },
                { title: 'Quản lý Bài Giảng', icon: 'fas fa-angle-right', link: '/learninghub_baigiang' },
                { title: 'Ngân hàng câu hỏi', icon: 'fas fa-angle-right', link: '/learninghub_cauhoi' },
                { title: 'Bài kiểm tra / Bài tập', icon: 'fas fa-angle-right', link: '/learninghub_dethi' },
                { title: 'Bài kiểm tra của tôi',enable:true, icon: 'fas fa-angle-right', link: '/bai-kiem-tra' },
                { title: 'Bài làm của thí sinh', icon: 'fas fa-angle-right', link: '/learninghub_bailam' },
                { title: 'Hướng dẫn giảng viên', id: 'learninghub_dethi', icon: 'fas fa-angle-right', link: '/huong-dan-learning-admin' },
                { title: 'Hướng dẫn học viên', enable: true, icon: 'fas fa-angle-right', link: '/huong-dan-learning-hoc-sinh' },
            ]
        },
        {
            title: 'Dịch vụ công nghệ', icon: 'fas fa-biohazard', link: '', active: ['/quan-ly-qrcode', '/may-cham-cong', '/checkin', '/blue-form'].includes(localsegment), children: [
                { title: 'Tạo QRcode', icon: 'fas fa-angle-right', link: '/quan-ly-qrcode' },
                { title: 'Quản lý máy chấm công', icon: 'fas fa-angle-right', link: '/may-cham-cong' },
                { title: 'Quản lý Checkin', icon: 'fas fa-angle-right', link: '/checkin' },
                { title: 'Blue Form', icon: 'fas fa-angle-right', link: '/blue-form' },
            ]
        },
        {
            title: 'Văn hóa/Truyền thông', icon: 'fas fa-bullhorn', link: '', active: ['/calendar', '/quan-ly-sticker'].includes(localsegment), children: [
                { title: 'Sự kiện', icon: 'fas fa-angle-right', link: '/calendar' },
                { title: 'Quản lý Sticker', icon: 'fas fa-angle-right', link: '/quan-ly-sticker' },
            ]
        },
        {
            title: 'Đăng ký/Giải trình', icon: 'fas fa-business-time', link: '', active: ['/list-users-break', '/list-giaitrinh'].includes(localsegment), children: [
                { title: 'Đăng ký chấm công', icon: 'fas fa-angle-right', link: '/list-users-break' },
                // { title: 'Đăng ký đi làm ngày lễ/Cuối tuần', icon: 'fas fa-angle-right', link: '/dang-ky-lam-le' },
                { title: 'Giải trình chấm công', icon: 'fas fa-angle-right', link: '/list-giaitrinh' },
            ]
        },
        {
            title: 'Phê duyệt', icon: 'fas fa-address-card', link: '', active: ['/list-approve-break', 'list-duyet-giai-trinh'].includes(localsegment), children: [
                { title: 'Duyệt đăng ký chấm công', icon: 'fas fa-angle-right', link: '/list-approve-break' },
                // { title: 'Phê duyệt Đăng ký đi làm ngày lễ/Cuối tuần', icon: 'fas fa-angle-right', link: '/duyet-dang-ky-lam-le' },
                { title: 'Duyệt giải trình chấm công', icon: 'fas fa-angle-right', link: '/list-duyet-giai-trinh' },
            ]
        },
        {
            title: 'Chấm công', icon: 'fas fa-calendar-alt', link: '', active: ['/list-users_onday', '/list-cham-cong-thang', '/upload-chamcong-bpmax', '/bangchotcongthang', '/tra-cuu-lich-su'].includes(localsegment), children: [
                { title: 'Bảng chấm công chi tiết', icon: 'fas fa-angle-right', link: '/list-users_onday' },
                { title: 'Bảng chấm công tháng', icon: 'fas fa-angle-right', link: '/list-cham-cong-thang' },
                { title: 'Bảng chốt công tháng', icon: 'fas fa-angle-right', link: '/bangchotcongthang' },
                { title: 'Upload chấm công BPMAX', icon: 'fas fa-angle-right', link: '/upload-chamcong-bpmax' },
                { title: 'Tra cứu lịch sử thay đổi', icon: 'fas fa-angle-right', link: '/tra-cuu-lich-su' },
            ]
        },

        {
            title: 'Nhân sự', icon: 'flaticon-user', link: '', active: ['/list-users','/nhan-su-nghi', '/users_ctv','/users_leave', '/users_gitiho', '/list-thuc-tap-sinh', '/users_login', '/link-ung-vien', '/hop-dong', '/mau-hop-dong', '/import-hop-dong', '/huong-dan-hop-dong', '/cay-nhan-su'].includes(localsegment), children: [
                { title: 'Danh sách nhân sự', icon: 'fas fa-angle-right', link: '/list-users' },
                { title: 'Cây nhân sự', icon: 'fas fa-angle-right', link: '/cay-nhan-su' },
                { title: 'Danh sách thực tập sinh', icon: 'fas fa-angle-right', link: '/list-thuc-tap-sinh' },
                { title: 'Danh sách ứng viên', icon: 'fas fa-angle-right', link: '/users_new' },
                { title: 'Link ứng viên', icon: 'fas fa-angle-right', link: '/link-ung-vien' },
                { title: 'Tân tuyển', icon: 'fas fa-angle-right', link: '/tan-tuyen' },
                { title: 'Quản lý CTV Sale', icon: 'fas fa-angle-right', link: '/users_ctv' },
                // { title: 'Quản lý tài khoản Gitiho', icon: 'fas fa-angle-right', link: '/users_gitiho' },
                { title: 'Theo dõi đăng nhập', icon: 'fas fa-angle-right', link: '/users_login' },
                { title: 'Mẫu hợp đồng', icon: 'fas fa-angle-right', link: '/mau-hop-dong' },
                { title: 'Hợp đồng', icon: 'fas fa-angle-right', link: '/hop-dong' },
                { title: 'Import hợp đồng', icon: 'fas fa-angle-right', link: '/import-hop-dong' },
                { title: 'Hướng dẫn hợp đồng', icon: 'fas fa-angle-right', link: '/huong-dan-hop-dong' },
                { title: 'Nhân sự nghỉ nhiều', icon: 'fas fa-angle-right', link: '/users_leave' },
                { title: 'Update thông tin nhân sự', icon: 'fas fa-angle-right', link: '/update-nhan-su' },
            ]
        },

        {
            title: 'Cẩm nang nội bộ', icon: 'fas fa-atlas', link: '', active: ['/danh-muc-tin', '/danh-sach-tin'].includes(localsegment), children: [
                { title: 'Danh mục', icon: 'fas fa-angle-right', link: '/danh-muc-tin' },
                { title: 'Cẩm nang nội bộ', icon: 'fas fa-angle-right', link: '/danh-sach-tin' },
            ]
        },
        {
            title: 'Cài đặt tổ chức', icon: 'fas fa-archway', link: '', active: ['/list-parts', '/che-do', '/lambu', '/vanthu_param', '/capbac', '/list-chucvu', '/list-company', '/list-users_onday_settings', 'cai-dat-nhan-su', '/cai-dat-ngay-chot-cong', '/cai-dat-cong'].includes(localsegment), children: [
                { title: 'Công ty thành viên', icon: 'fas fa-angle-right', link: '/list-company' },
                { title: 'Phòng ban', icon: 'fas fa-angle-right', link: '/list-parts' },
                { title: 'Danh sách chức vụ', icon: 'fas fa-angle-right', link: '/list-chucvu' },
                { title: 'Danh sách cấp bậc', icon: 'fas fa-angle-right', link: '/capbac' },
                // { title: 'Ca làm việc', icon: 'fas fa-angle-right', link: '/list-ca-lam' },
                { title: 'Quản lý ca làm', icon: 'fas fa-angle-right', link: '/quan-ly-ca' },
                { title: 'Phân ca làm', icon: 'fas fa-angle-right', link: '/phan-ca-lam' },
                { title: 'Cài đặt nhân sự', icon: 'fas fa-angle-right', link: '/cai-dat-nhan-su' },
                { title: 'Cài đặt ngày chốt công', icon: 'fas fa-angle-right', link: '/cai-dat-ngay-chot-cong' },
                { title: 'Cài đặt công', icon: 'fas fa-angle-right', link: '/cai-dat-cong' },
                { title: 'Ngày lễ, ngày nghỉ, NVP', icon: 'fas fa-angle-right', link: '/ngay-le' },
                { title: 'Nghỉ chế độ', icon: 'fas fa-angle-right', link: '/che-do' },
                { title: 'Quản lý ngày làm bù', icon: 'fas fa-angle-right', link: '/lambu' },
            ]
        },
        {
            title: 'Báo cáo', icon: 'fas fa-chart-bar', link: '', active: ['/bao-cao-xe-phong-hop', '/bao-cao-nhan-su'].includes(localsegment), children: [
                { title: 'Báo cáo DV hành chính', icon: 'fas fa-angle-right', link: '/bao-cao-xe-phong-hop' },
                { title: 'Báo cáo nhân sự', icon: 'fas fa-angle-right', link: '/bao-cao-nhan-su' },
            ]
        },
        {
            title: 'Cài đặt hệ thống', icon: 'fas fa-cogs', link: '', active: ['/list-settings', '/test-email', '/danh-sach-gui-mail', '/quan-ly-sticker'].includes(localsegment), children: [
                { title: 'Cài đặt thông số', icon: 'fas fa-angle-right', link: '/list-settings' },
                { title: 'Phân quyền', icon: 'fas fa-angle-right', link: '/list-roles' },
                { title: 'Test gửi mail', icon: 'fas fa-angle-right', link: '/test-email' },
                { title: 'Danh sách gửi mail', icon: 'fas fa-angle-right', link: '/danh-sach-gui-mail' },

            ]
        },
    ];

    const checkRole = (idparent, menu) => {
        let isrole = false;
        let id = menu.id;
        if (!id) id = _.trimStart(menu.link, ' /');
        if (id) {
            if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(id) && MyRole[idparent].children[id].checked === true) isrole = true
            else if (MyRole.hasOwnProperty(id) && MyRole[id].checked === true) isrole = true
        } else {
            if (menu.hasOwnProperty('children') && menu.children && menu.children.length > 0) {
                menu.children.map((sub) => {
                    let idsub = _.trimStart(sub.link, ' /');
                    if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(idsub) && MyRole[idparent].children[idsub].checked === true) isrole = true
                    else if (idsub && MyRole.hasOwnProperty(idsub) && MyRole[idsub].checked === true) isrole = true
                    return sub;
                })
            }
        }
        // if(menu.link === '/marktests') console.log(MyRole);
        return isrole
    }
    //Hàm xử lý đăng xuất
    const dologout = () => {
        confirmAlert({
            title: "Đăng xuất",
            message: "Bạn có chắc muốn đăng xuất",
            closeOnEscape: true,
            closeOnClickOutside: true,
            buttons: [
                {
                    label: "Đăng xuất",
                    onClick: () => {
                        dispatch(resetRedux());
                        dispatch(actions.login(null));
                    },
                },
                { label: "Không" },
            ],
        });
    };

    const subMenu = (idparent, list, active) => {
        return <>
            {list && list.length > 0 ? <ul className={`nav sub-group-menu ` + (active ? 'menu-open' : '')} style={{ display: (active ? 'block' : 'none') }}>
                {list.map((item, i) => {
                    let title = item.title
                    let DKchoDuyet = countcv && countcv.DKchoDuyet ? countcv.DKchoDuyet : 0
                    let GTchuaGui = countcv && countcv.GTchuaGui ? countcv.GTchuaGui : 0
                    let DKchuaDuyet = countcv && countcv.DKchuaDuyet ? countcv.DKchuaDuyet : 0
                    let GTchuaDuyet = countcv && countcv.GTchuaDuyet ? countcv.GTchuaDuyet : 0
                    let workflow_waiting = countcv && countcv.workflow_waiting ? countcv.workflow_waiting : []

                    let myjob = countcv && countcv.myjob ? countcv.myjob : []

                    if (title == 'Đăng ký chấm công' && DKchoDuyet > 0) {
                        title = <><span>Đăng ký chấm công</span><span className="sub-sp">{DKchoDuyet}</span></>
                    } else if (title == 'Giải trình chấm công' && GTchuaGui > 0) {
                        title = <><span>Giải trình chấm công</span><span className="sub-sp">{GTchuaGui}</span></>
                    } else if (title == 'Duyệt đăng ký chấm công' && DKchuaDuyet > 0) {
                        title = <><span>Duyệt đăng ký chấm công</span><span className="sub-sp">{DKchuaDuyet}</span></>
                    } else if (title == 'Duyệt giải trình chấm công' && GTchuaDuyet > 0) {
                        title = <><span>Duyệt giải trình chấm công</span><span className="sub-sp">{GTchuaDuyet}</span></>
                    } else if (title == 'Quản lý công việc' && myjob > 0) {
                        title = <><span>{title}</span><span className="sub-sp">{myjob}</span></>
                    } else if (item.link == '/workflow_walking' && workflow_waiting.length > 0) {
                        title = <><span>{title}</span><span className="sub-sp">{workflow_waiting.length}</span></>
                    } else {
                        title = <span>{title}</span>
                    }
                    let checkrole = checkRole(idparent, item) || (item && item.enable)

                    if (checkrole) {
                        return <li className="nav-item" key={i}>
                            <Link to={item.link} className={`nav-link ${isMenuActive(item.link) ? 'menu-active' : ''}`}>
                                <i className="fas fa-angle-right"></i>
                                {title}
                            </Link>
                        </li>
                    } else return null
                })}
            </ul> : null}
        </>
    }

    return (
        <>
            {/* Sidebar Area Start Here */}
            <div className={"col-12 col-sm-2 sidebar-main sidebar-menu-one p-0 sidebar-color " + (menuShow ? " menu-show" : "")}>

                <div className="mobile-sidebar-header d-md-none">
                    <a href="/my-profile" className="w-100 d-flex u-info">
                        <div className="admin-img">
                            <img src={info && info.avatar ? info.avatar : Avatar} alt="Admin" />
                        </div>

                        <div className="admin-title">
                            <h5 className="item-title">
                                {info.fullname} {" "}
                            </h5>
                            <span>{info.chucvu}</span>
                        </div>

                    </a>
                </div>
                <div className="sidebar-menu-content">
                    <ul className="nav nav-sidebar-menu sidebar-toggle-view">
                        <li className={`nav-item ` + ('bang-tin' === localsegment ? 'menu-active' : '')}>
                            <Link to={"/bang-tin"} className={`nav-link text-white`}>
                                <img src={trau} className='icon-post' alt='Cộng đồng Blue' />Cộng đồng Blue</Link>
                        </li>

                        {listMenus.map((item, i) => {
                            let checkrole = (checkRole(null, item) || item.role) || (item && item.enable)
                            // console.log(item);
                            
                            if (checkrole) {
                                let title = item.title
                                let DKchoDuyet = countcv && countcv.DKchoDuyet ? countcv.DKchoDuyet : 0
                                let GTchuaGui = countcv && countcv.GTchuaGui ? countcv.GTchuaGui : 0
                                let DKchuaDuyet = countcv && countcv.DKchuaDuyet ? countcv.DKchuaDuyet : 0
                                let GTchuaDuyet = countcv && countcv.GTchuaDuyet ? countcv.GTchuaDuyet : 0
                                let workflow_waiting = countcv && countcv.workflow_waiting ? countcv.workflow_waiting : []
                                let myjob = countcv && countcv.myjob ? countcv.myjob : 0
                                if (title == 'Đăng ký/Giải trình' && (DKchoDuyet + GTchuaGui) > 0) {
                                    title = <><span>Đăng ký</span><span className="sub-sp">{DKchoDuyet}</span><span> - Giải trình</span><span className="sub-sp">{GTchuaGui}</span></>
                                } else if (title == 'Phê duyệt' && (DKchuaDuyet + GTchuaDuyet) > 0) {
                                    title = <><span>Phê duyệt</span><span className="sub-sp">{DKchuaDuyet + GTchuaDuyet}</span></>
                                } else if (title == 'Tờ trình' && (workflow_waiting.length) > 0) {
                                    title = <><span>Tờ trình</span><span className="sub-sp">{workflow_waiting.length}</span></>
                                } else if (title == 'Quản lý công việc' && (myjob) > 0) {
                                    title = <><span>{title}</span><span className="sub-sp">{myjob}</span></>
                                } else {
                                    title = <span>{title}</span>
                                }
                                let menuactive = false
                                if (item.children) {
                                    item.children.map((itemMN, i) => {
                                        if (isMenuActive(itemMN.link)) menuactive = true
                                        return itemMN
                                    })
                                }
                                return <li key={i} className={`nav-item ${item.children ? 'sidebar-nav-item' : ''} ` + (menuactive ? 'active' : '')}>
                                    {!item.children ?
                                        <Link to={item.link} className={`nav-link ${isMenuActive(item.link) ? 'menu-active' : ''}`}>
                                            <i className={item.icon}></i>{title}</Link>
                                        :
                                        <div to={item.link} className={`nav-link ${isMenuActive(item.link) || menuactive ? 'menu-active' : ''}`}><i
                                            className={item.icon}></i>{title}</div>}
                                    {subMenu(item.id, item.children, menuactive)}
                                </li>
                            } else return null
                        })}
                        <li className="nav-item">
                            <a href="#logout" onClick={() => window.location.reload()} className="nav-link">
                                <i className="fas fa-crosshairs"></i><span>Tải lại trang</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href="#logout" onClick={dologout} className="nav-link">
                                <i className="flaticon-turn-off"></i><span>Đăng xuất</span>
                            </a>
                        </li>
                    </ul>

                </div>
            </div>

            {/* Sidebar Area End Here */}
        </>
    );
}
